import {
  academicFlags,
  academicPointPerson,
  attendanceFlags,
  attendancePointPerson,
  otherStaff,
  postsecondaryPointPerson,
  studentName,
} from './my-students-mad-lib-columns.constant';

export const emsFlagOptions = [
  {
    human: 'Flags',
    key: 'FLAGS',
    columns: {
      0: studentName,
      10: attendanceFlags,
      20: academicFlags,
    },
  },
];

export const emsPointPeopleOptions = [
  {
    human: 'Point people',
    key: 'POINT_PEOPLE',
    columns: {
      0: studentName,
      10: attendancePointPerson,
      20: academicPointPerson,
      40: otherStaff,
    },
  },
];

export const hsFlagOptions = [
  {
    human: 'Flags',
    key: 'FLAGS',
    columns: {
      0: studentName,
      10: attendanceFlags,
      20: academicFlags,
    },
  },
];

export const hsPointPeopleOptions = [
  {
    human: 'Point people',
    key: 'POINT_PEOPLE',
    columns: {
      0: studentName,
      10: attendancePointPerson,
      20: academicPointPerson,
      30: postsecondaryPointPerson,
      40: otherStaff,
    },
  },
];
